// extracted by mini-css-extract-plugin
export default {"interview-trainer":"AOus1","title":"sn2SG","subtitle":"uNDNM","interview-trainer-wrapper":"oU6PR","title-block":"GN6QN"};